module.exports = __webpack_public_path__ + "img/xls.a48a26cb.png";